import { ApiMethod, get, getRaw, post, postRaw } from 'services/api';
import { useRestMutation } from 'utils/hooks/api';
import { addFilteredParams } from 'utils/urlParams';
import client from './ApolloClient';
import { SEGMENT_USERS_QUERY } from './ListsApi';
import { fetchExperimentVariants } from './queries';

export const STATS_FOR_TIMERANGE_URL = '/analytics/getStatsForTimeRange';
export const UPDATE_LABELS_URL = '/i/campaignLabels/';
export const CAMPAIGN_LINK_STATS = '/analytics/getCampaignLinkStats';
export const DYNAMIC_LINK_STATS = '/analytics/getDynamicCampaignLinkStats';
export const CAMPAIGN_METRICS_URL = '/analytics/getMetricsForCampaign';
export const MOBILE_APPS_URL = '/integrations/mobileApps.json';
export const DATAFEED_DATA_URL = '/i/templates/templateFeeds';

export const getStatsForTimeRange = (queryData) => post(STATS_FOR_TIMERANGE_URL, queryData);

export const updateCampaignLabels = (id, queryData) => post(`${UPDATE_LABELS_URL}${id}`, queryData);

export const getMetricsForCampaign = (queryData) => post(CAMPAIGN_METRICS_URL, queryData);

export const getDestinations = () => get(MOBILE_APPS_URL);

export const getSegmentUsers = (opts) => post(SEGMENT_USERS_QUERY, opts);

export const useGetSegmentUsers = (options) =>
  useRestMutation(SEGMENT_USERS_QUERY, ApiMethod.post, options);

export const getCampaignLinkStats = ({
  id,
  startDate,
  endDate,
  urlOnlyView,
  templateId,
  userUUID,
  userEmail,
}) => {
  const url = addFilteredParams(CAMPAIGN_LINK_STATS, {
    campaignId: id,
    urlOnlyView,
    start: startDate,
    end: endDate,
    templateId,
    ...(userUUID ? { userUUID } : { userEmail }),
  });

  return get(url);
};

export const getDynamicLinkStats = ({
  id,
  startDate,
  endDate,
  templateId,
  userUUID,
  userEmail,
}) => {
  const url = addFilteredParams(DYNAMIC_LINK_STATS, {
    campaignId: id,
    start: startDate,
    end: endDate,
    templateId,
    ...(userUUID ? { userUUID } : { userEmail }),
  });

  return getRaw(url);
};

export const getLinkTrackedHtml = (contentId, templateId, jsonData) => {
  const baseUrl = `/templates/getLinkTrackedHtml?contentId=${contentId}&templateId=${templateId}`;
  const url = jsonData ? `${baseUrl}&jsonData=${encodeURIComponent(jsonData)}` : baseUrl;
  return getRaw(url);
};

export const getUserData = (userId, userDataType) => {
  return getRaw(`/users/profiles/getUserData?${userDataType}=${encodeURIComponent(userId)}`);
};

export const getDataFeedData = (templateId, userData = {}) =>
  postRaw(DATAFEED_DATA_URL, {
    templateId,
    userData,
  });

export const fetchExperimentVariantList = (id) =>
  client.query({ query: fetchExperimentVariants, variables: { id } });
